import Vue from 'vue';
import Router from 'vue-router';
// Views
import Dashboard from '@/views/dashboard/Dashboard.vue';
import Wallboard from '@/views/wallboard/Wallboard.vue';
import Schedule from '@/views/schedule/Schedule.vue';
import JobSearch from '@/views/job/search/JobSearch.vue';
import JobCreate from '@/views/job/create/JobCreate.vue';
import JobView from '@/views/job/view/JobView.vue';
import BulkEditJobItems from '@/views/job/view/processes/BulkEditJobItems.vue';
import ImportJobs from '@/views/job/import/ImportJobs.vue';
import JobActivityQuickEntry from '@/views/job/activity/JobActivityQuickEntry.vue';
import PrintJobSheet from '@/views/job/print/PrintJobSheet.vue';
import AdminDashboard from '@/views/admin/AdminDashboard.vue';
import EmployeeList from '@/views/admin/employee/EmployeeList.vue';
import NetworkList from '@/views/admin/network/NetworkList.vue';
import ServiceTypeList from '@/views/admin/servicetype/ServiceTypeList.vue';
import TravelTimeList from '@/views/admin/traveltime/TravelTimeList.vue';
import MissedInvoicesList from '@/views/admin/missedinvoices/MissedInvoicesList.vue';

// Services
import AuthService from '@/services/auth.service';

Vue.use(Router);

const auth = new AuthService();

const router = new Router({
  routes: [
    { path: '/', name: 'dashboard', component: Dashboard, meta: { requiresAuth: true } },
    { path: '/wallboard', name: 'wallboard', component: Wallboard, meta: { layout: 'blank' }  }, // Does not require auth
    { path: '/jobs', name: 'jobsearch', component: JobSearch, meta: { requiresAuth: true } },
    { path: '/jobs/create', name: 'jobcreate', component: JobCreate, meta: { requiresAuth: true } },
    { path: '/jobs/view/:gid', name: 'jobview', component: JobView, meta: { requiresAuth: true } },
    { path: '/jobs/view/:gid/bulk-edit-items', name: 'bulkeditjobitems', component: BulkEditJobItems, meta: { requiresAuth: true } },
    { path: '/jobs/import', name: 'jobimport', component: ImportJobs, meta: { requiresAuth: true } },
    { path: '/jobs/addactivity', name: 'jobaddactivity', component: JobActivityQuickEntry, meta: { requiresAuth: true } },
    { path: '/jobs/print/:gid', name: 'jobsheetprint', component: PrintJobSheet, meta: { requiresAuth: true, layout: 'print-landscape' } },
    { path: '/schedule', name: 'schedule', component: Schedule, meta: { requiresAuth: true } },
    { path: '/clients', name: 'clientsearch', component: () => import(/* webpackChunkName: "client" */ './views/client/search/ClientSearch.vue'), meta: { requiresAuth: true } },
    { path: '/clients/create', name: 'clientcreate', component: () => import(/* webpackChunkName: "client" */ './views/client/create/ClientCreate.vue'), meta: { requiresAuth: true } },
    { path: '/clients/edit/:gid', name: 'clientedit', component: () => import(/* webpackChunkName: "client" */ './views/client/edit/ClientEdit.vue'), meta: { requiresAuth: true } },
    { path: '/account/resetpassword', name: 'resetpassword', component: () => import(/* webpackChunkName: "account" */ './views/account/ResetPassword.vue'), meta: { layout: 'blank' }},
    { path: '/account/completeresetpassword', name: 'completeresetpassword', component: () => import(/* webpackChunkName: "account" */ './views/account/CompleteResetPassword.vue'), meta: { layout: 'blank' }},
    { path: '/accounting/batches', name: 'invoicebatches', component: () => import(/* webpackChunkName: "accounting" */ './views/accounting/batches/list/InvoiceBatchList.vue'), meta: { requiresAuth: true } },
    { path: '/accounting/batches/view/:gid', name: 'invoicebatchview', component: () => import(/* webpackChunkName: "accounting" */ './views/accounting/batches/view/ViewInvoiceBatch.vue'), meta: { requiresAuth: true } },
    { path: '/admin', name: 'admin', component: AdminDashboard, meta: { requiresAuth: true },
      children: [
        { path: '', redirect: 'missed-invoices' },
        { path: 'missed-invoices', name: 'missedinvoices', component: MissedInvoicesList },
        {path: 'employees', name: 'employees', component: EmployeeList},
        {path: 'networks', name: 'networks', component: NetworkList},
        {path: 'servicetypes', name: 'servicetypes', component: ServiceTypeList},
        {path: 'traveltimes', name: 'traveltimes', component: TravelTimeList}
      ]
    },
    { path: '/development', name: 'uielementpreview',
    children: [
      {path: 'uicomponents', name: 'uicomponents', component: () => import(/* webpackChunkName: "devui" */ './views/development/pages/UIComponents.vue')},
      {path: 'schedulecard', name: 'schedulecard', component: () => import(/* webpackChunkName: "devui" */ './views/development/pages/ScheduleCardExample.vue')},

    ],
    component: () => import(/* webpackChunkName: "devui" */ './views/development/UIElementPreview.vue')},
  ],
});


router.beforeEach((to: any, from: any, next: any) => {
  if (to.matched.some((record: any) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    auth.getUser().then((user) => {
      if (user !== null && !user.expired) {
        // logged in
        next();
      } else {
        // not logged in

        window.localStorage.setItem('authpage', window.location.href);

        auth.login();
      }
    });
  } else {
    // doesn't require auth
    next(); // make sure to always call next()!
  }
});

export default router;
